import React from "react";
import love from "../../assets/images/love.svg";
export default function LeftPart() {
    return (
        <div>
            <img src={love} alt="" />
        </div>
    );
}
